import type { ReactNode } from 'react';
import styles from './Terminal.module.css';

interface TerminalProps {
  children: ReactNode;
  title?: string;
  className?: string;
}

/**
 * Terminal container component.
 *
 * Wraps content in a DOS-style terminal window with
 * optional title bar and consistent styling.
 */
export function Terminal({ children, title = 'FULL STACK CONSULTING', className = '' }: TerminalProps) {
  return (
    <div className={`${styles.terminal} ${className}`}>
      <div className={styles.titleBar}>
        <span className={styles.title}>{title}</span>
      </div>
      <div className={styles.content}>
        {children}
      </div>
    </div>
  );
}
